import { FlyerDetailPageState } from "./flyer-detail-page-state.interface";

export function createFlyerDetailPageState(): FlyerDetailPageState {
  return {
    pagePreview: null,
    editPagePositionId: null,
    template: null,
    editingType: "page",
    selectedLanguage: "en",
    isLoading: false,
  };
}
